import { Component, OnInit } from '@angular/core';
import { Skins } from 'src/app/objects/skins';
import { EventService } from 'src/app/services/event.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EventInfo } from 'src/app/objects/EventInfo';

@Component({
  selector: 's18-skins',
  templateUrl: './skins.component.html',
  styleUrls: ['./skins.component.scss']
})
export class SkinsComponent implements OnInit {
  skins: any;
  multiRoundSkins: Skins[] = [];
  loading : boolean = false;
  eventInfo : EventInfo = {} as EventInfo;

  constructor(
    private eventService : EventService,
    private activeRoute : ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.activeRoute.params.subscribe(params => {
      let group_event_id = params["group_event_id"];
      this.loading = true;
      this.eventService.getEventInfo(group_event_id)
        .subscribe(resp => {
          this.eventInfo = JSON.parse(resp.d).event_info;

          // Redirect GGK+ events to event-builder results page
          const eventType = Number(this.eventInfo.event_type);
          if (eventType > 2) {
            const groupId = this.eventInfo.group_id;
            this.router.navigateByUrl(`/event-builder/${groupId}/${group_event_id}/3/results`);
            return;
          }

          this.eventService.getEventSkins(group_event_id).subscribe(response => this.parseEventSkins(response));
        });
    })
    
  }

  getFlightLetter(flight: string): string {
    var f = +flight;
    switch (f) {
      case 1:
        return 'A';
      case 2:
        return 'B';
      case 3:
        return 'C';
      case 4:
        return 'D';
      case 5:
        return 'E';
      case 6:
        return 'F';
      case 7:
        return 'G';
      case 8:
        return 'H';
    }
  }

  parseEventSkins(resp: any){
    this.loading = false;
    this.skins = JSON.parse(resp.d).skins;

    if ( this.skins.skins ){
      if ( !Array.isArray(this.skins.skins)){
        this.skins.skins = Array.of(this.skins.skins);
      }
    }
  }
  
  hasSkins(): boolean {
    if (this.skins || this.multiRoundSkins.length>0) {
      return true;
    }
    return false;
  }

  hasFlightedSkins(): boolean {
    if ( this.skins && this.skins.skins ){
      return true;
    }
    return false;

  }

}
